<template>
    <el-dialog
        :title="title"
        :visible.sync="dialogFormVisible"
        :before-close="close"
        custom-class="save-property-modal"
    >
        <el-form
            :model="form"
            ref="form"
        >
            <el-form-item
                label="所在地"
                prop="address"
                :label-width="formLabelWidth"
                :rules="[{ required: true, message: '所在地は必須項目です', trigger: 'blur' }]"
            >
                <el-input v-model="form.address" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item
                label="価格"
                prop="land_price"
                :label-width="formLabelWidth"
                :rules="[{ required: true, message: '価格は必須項目です', trigger: 'blur' }]"
            >
                <el-input v-model="form.land_price" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item
                label="土地面積(平米)"
                prop="land_area_squere"
                :label-width="formLabelWidth"
                :rules="[{ required: true, message: '土地面積(平米)は必須項目です', trigger: 'blur' }]"
            >
                <el-input v-model="form.land_area_squere" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item
                label="土地面積(坪)"
                prop="land_area_unit"
                :label-width="formLabelWidth"
                :rules="[{ required: true, message: '土地面積(坪)は必須項目です', trigger: 'blur' }]"
            >
                <el-input v-model="form.land_area_unit" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item
                label="道路幅員(クローラー)"
                prop="road_width"
                :label-width="formLabelWidth"
                :rules="[{ required: true, message: '道路幅員(m)は必須項目です', trigger: 'blur' }]"
            >
                <el-input v-model="form.road_width" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item
                label="道路幅員(表示)"
                prop="road_width"
                :label-width="formLabelWidth"
            >
                <el-input :value="previewRoadWidth(form.road_width)" autocomplete="off" disabled></el-input>
            </el-form-item>

            <el-form-item
                label="容積率(クローラー)"
                prop="floor_area_ratio"
                :label-width="formLabelWidth"
                :rules="[{ required: true, message: '容積率は必須項目です', trigger: 'blur' }]"
            >
                <el-input v-model="form.floor_area_ratio" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item
                label="容積率(表示)"
                prop="floor_area_ratio"
                :label-width="formLabelWidth"
            >
                <el-input :value="previewFloorAreaRatio(form.floor_area_ratio)" autocomplete="off" disabled></el-input>
            </el-form-item>

            <el-form-item
                label="建蔽率"
                prop="building_coverage"
                :label-width="formLabelWidth"
                :rules="[{ required: true, message: '建蔽率は必須項目です', trigger: 'blur' }]"
            >
                <el-input v-model="form.building_coverage" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item
                label="最寄り駅"
                prop="closest_stations"
                :label-width="formLabelWidth"
                :rules="[{ required: true, message: '最寄り駅は必須項目です', trigger: 'blur' }]"
            >
                <el-input v-model="form.closest_stations" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item
                label="徒歩分数"
                prop="walk_minutes"
                :label-width="formLabelWidth"
                :rules="[{ required: true, message: '徒歩分数は必須項目です', trigger: 'blur' }]"
            >
                <el-input v-model="form.walk_minutes" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item
                label="距離"
                prop="distance"
                :label-width="formLabelWidth"
                :rules="[{ required: true, message: '距離は必須項目です', trigger: 'blur' }]"
            >
                <el-input v-model="form.distance" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item
                label="用途地域"
                prop="use_zones"
                :label-width="formLabelWidth"
                :rules="[{ required: true, message: '用途地域は必須項目です', trigger: 'blur' }]"
            >
                <el-input v-model="form.use_zones" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item
                label="取得日時"
                prop="acquisition_date"
                :label-width="formLabelWidth"
                :rules="[{ required: true, message: '取得日時は必須項目です', trigger: 'blur' }]"
            >
                <el-date-picker
                    v-model="form.acquisition_date"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="取得日時を入力してください">
                </el-date-picker>
            </el-form-item>

            <el-form-item label="セットバック" :label-width="formLabelWidth">
                <el-radio-group v-model="form.setback">
                    <el-radio :label="1">あり</el-radio>
                    <el-radio :label="0">なし</el-radio>
                </el-radio-group>
            </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">キャンセル</el-button>
            <el-button type="primary" @click="update('form')">更新</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {

    props: {
        dialogFormVisible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            required: true
        },
        form: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            formLabelWidth: '120px'
        }
    },

    methods: {
        close() {
            this.$emit('close')
        },
        update(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$emit('update', this.form)
                } else {
                    return false
                }
            });
        },
        previewRoadWidth(roadWidth) {
            let previewRoadWidth = this.retrieveNumber(roadWidth)

            if (previewRoadWidth != null) {
                return previewRoadWidth += '㎡'
            }

            return '不明'
        },
        previewFloorAreaRatio(floorAreaRatio) {
            let previewFloorAreaRatio = this.retrieveNumber(floorAreaRatio)

            if (previewFloorAreaRatio != null) {
                return previewFloorAreaRatio += '%'
            }

            return '不明'
        },
        // 数値を切り取る
        retrieveNumber(value) {
            if (value == null) {
                return null
            }

            let regex = /\d+\.*\d*/g
            let retrievedNumber = value.match(regex)

            return retrievedNumber
        }

    }
}
</script>

<style>
.el-date-editor.el-input {
    width: 100% !important;
}

.el-form-item__label {
    font-size: 10px !important;
}

.save-property-modal {
    width: 95% !important;
    max-width: 700px !important;
}
</style>